<template>
  <v-card>
    <div v-if="paymentMethodType[tabType]" class="container-overall-payment">
      <div v-for="(itemHeader, indexHeader) in paymentMethodType[tabType]" :key="indexHeader">
        <v-alert class="my-3 box-overall" :class="paymentMethodTypeBoxColor[indexHeader]" elevation="1" border="left">
          <v-card-title class="border-rd-none justify-space-between align-center" :class="paymentMethodTypeColor[indexHeader]">
            <div> {{ indexHeader }} {{ $helper.toCurrency(itemHeader.sum)  }} {{ $helper.currencyThEn(tabType) }} </div>
            <div v-if="indexHeader == $t('payment.paid')">{{itemHeader.countIsPaid}} {{ $t('bill.receipt') }}</div>
            <div v-if="indexHeader == $t('payment.cancel_payment')">{{itemHeader.countCancelled}} {{ $t('bill.receipt') }}</div>
          </v-card-title>
          <template v-if="Object.keys(itemHeader.data).length > 0">
            <template v-for="(item, index) in itemHeader.data">
              <template>
                <v-card-text style="padding:16px;" >
                  <div class="total-header">
                    <div>{{ index }} {{ $helper.toCurrency(item.sum)  }} {{ $helper.currencyThEn(tabType) }}</div>
                  </div>
                  <div class="total-detail pl-5" v-if="item.type">
                    <div v-for="(itemIn, indexIn) in item.type" :key="indexIn">
                      <div v-if="!itemIn.data">
                        {{ $t('payment.received_by') }}
                        <p class="text-name">{{ indexIn }}<b>:</b></p>
                        
                        <p class="text-bath">{{ $helper.toCurrency(itemIn.sum)  }} {{ $helper.currencyThEn(tabType) }}</p>
                      </div>
                      <template v-else>
                        <div>
                          <div class="text-name-bank">
                            <img style="display: inline" width="40" alt="bank"
                              :src="require(`@/assets/images/bank/${itemIn.data.bankCode}.jpg`)" />
                            {{ BankData[itemIn.data.bankCode].name }}
                            ({{ itemIn.data.accountName }} {{ itemIn.data.accountNumber }})<b>:</b>
                          </div>
                          
                          <p class="text-bath">{{ $helper.toCurrency(itemIn.sum)  }} {{ $helper.currencyThEn(tabType) }}</p>
                        </div>
                      </template>
                    </div>
                  </div>
                </v-card-text>
              </template>
            </template>
          </template>
          <template v-else>
            <v-card-text style="padding:16px;" >
              <div class="text-center">
                <h3 class="mb-0">{{ $t('no_list') }}</h3>
              </div>
            </v-card-text>
          </template>
        </v-alert>
      </div>
    </div>
    <div v-else>
      <div class="container-overall-payment">
        <v-alert class="my-3 box-overall border-green order-1" elevation="1" border="left">
          <v-card-title class="justify-space-between align-center" :class="paymentMethodTypeColor[$t('payment.paid')]">
              <div> {{ $t('payment.paid') }} {{ 0 | currencySuffixTextThEn(tabType) }} </div>
              <div>0 {{ $t('bill.receipt') }}</div>
            </v-card-title>
          <v-card-text style="padding:16px;" >
            <div class="text-center">
              <h3 class="mb-0">{{ $t('no_list') }}</h3>
            </div>
          </v-card-text>
        </v-alert>
        <v-alert class="my-3 box-overall border-gray order-2" elevation="1" border="left">
          <v-card-title class="justify-space-between align-center" :class="paymentMethodTypeColor[$t('payment.cancel_payment')]">
              <div> {{ $t('payment.cancel_payment') }}  {{ 0 | currencySuffixTextThEn(tabType) }} </div>
              <div>0 {{ $t('bill.receipt') }}</div>
            </v-card-title>
          <v-card-text style="padding:16px;" >
            <div class="text-center">
              <h3 class="mb-0">{{ $t('no_list') }}</h3>
            </div>
          </v-card-text>
        </v-alert>
      </div>
    </div>
  </v-card>
</template>

<script>
import BankData from "@/json/bank-data.json";

export default {
  name: 'CardReceiptOverAll',
  props: {
    paymentMethodType: {
      type: Object,
      required: true
    },
    countReceipt: {
      type: Number,
      required: true
    },
    tabType: {
      type: String,
      default: 'THB'
    }
  },
  data(){
    return {
      paymentMethodTypeColor: {
        [this.$t('payment.paid')]: "bg-green-100 green--text",
        [this.$t('payment.cancel_payment')]: "bg-dark-gray dark--text",
        [this.$t('payment.pending')]: "bg-red-100 red--text"
      },
      paymentMethodTypeBoxColor: {
        [this.$t('payment.cancel_payment')]: "border-gray order-2",
        [this.$t('payment.paid')]: "border-green order-1",
        [this.$t('payment.pending')]: "border-red"
      },
      BankData
    }
  },
}
</script>

<style lang="scss" scoped>

.total-header {
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.total-detail {
  font-size: 16px;

  .text-name {
    min-width: 200px;
    display: inline-block;
    font-weight: bold;
    padding-left: 10px;
  }

  .text-name-bank {
    min-width: 400px;
    display: inline-block;
    font-weight: bold;
    padding-left: 10px;
  }

  .text-bath {
    min-width: 150px;
    display: inline-block;
    // text-align: right;
  }
}

.bg-dark-gray{
  background-color: #EEEEEE;
  color: #424242;
}
</style>

<style lang="scss">
.container-overall-payment{
  display: grid;
  gap: 10px;
  padding: 10px;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 25px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
  .box-overall{
    height: 100%;
    padding: 0 0 0 7px;
    .border-rd-none{
      border-radius: 0px !important;
    }
    &.order-1{
      order: 1;
    }
    &.order-2{
      order: 2;
    }
    &.border-green{
      .v-alert__border{
        border-color: #47BD82 !important;
        opacity: 1;
      }
    }
    &.border-gray{
      .v-alert__border{
        border-color: #A9A9A9 !important;
        opacity: 1;
      }
    }
    &.border-red{
      .v-alert__border{
        border-color: #EB5455 !important;
        opacity: 1;
      }
    }
  }
}
</style>